// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"479":"5bab3ac7","762":"63a6394a","868":"59f85c4b"}[chunkId] + ".css";
};